import { render } from "./TaskView.vue?vue&type=template&id=78d724ac&scoped=true"
import script from "./TaskView.vue?vue&type=script&lang=js"
export * from "./TaskView.vue?vue&type=script&lang=js"

import "./TaskView.vue?vue&type=style&index=0&id=78d724ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78d724ac"]])

export default __exports__